import React from "react";
import Logo from "../../assets/logo-nanthiat.png";

export default function Profile({ user, onLogout }) {
  return (
    <div className="z-[999] max-w-sm mx-auto bg-white shadow-lg rounded-xl overflow-hidden p-6 dark:bg-gray-800">
      {/* Image de profil */}
      <div className="flex justify-center">
        <img
          className="h-24 w-24 rounded-full object-cover border-4 border-blue-900" // ✅ Bleu foncé autour du logo
          src={user?.profileImage || Logo}
          alt="Profil utilisateur"
        />
      </div>

      {/* Informations du profil */}
      <div className="text-center mt-4">
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white">{user?.Nom || "Utilisateur"}</h2>
        <p className="text-gray-600 dark:text-gray-400 text-sm">{user?.Rôle || "Rôle non défini"}</p>
      </div>

      {/* Détails supplémentaires */}
      <div className="mt-4 text-sm text-gray-700 dark:text-gray-300">
        <p><span className="font-semibold">Email :</span> {user?.email || "Non renseigné"}</p>
        <p><span className="font-semibold">Téléphone :</span> {user?.telephone || "Non renseigné"}</p>
        <p><span className="font-semibold">Adresse :</span> {user?.adresse || "Non renseignée"}</p>
      </div>

      {/* Bouton Déconnexion centré */}
      <div className="mt-6 flex justify-center">
        <button
          className="px-6 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition"
          onClick={onLogout}
        >
          Se Déconnecter
        </button>
      </div>
      {/* ✅ Version Alpha en italique */}
      <p className="mt-2 text-gray-500 italic text-sm text-center">Alpha V0.0.2.1</p>
    </div>
  );
}
